import { useEffect, useMemo } from 'react';

import { SettingsMenu } from './settings-menu';
import { uiStore } from '../../../core/stores/ui-store';
import { context } from '../../../app/context';
import { observer } from 'mobx-react-lite';

const baseMenu = [
  {
    key: 'general',
    label: 'General',
    href: `../settings/general`,
  },
  {
    key: 'billings',
    label: 'Billing',
    href: `../settings/billings`,
  },
  {
    key: 'plans',
    label: 'Plans',
    href: `../settings/plans`,
  },
  {
    key: 'users',
    label: 'Users',
    href: `../settings/users`,
  },
  {
    key: 'storage',
    label: 'Storage',
    href: `../settings/storage`,
  },
];

export const MobileSettingsNavigation = observer(() => {
  const space = context.space;

  const menu = useMemo(() => {
    const items = [...baseMenu];

    if (space?.flags?.isDeveloperAccessible) {
      items.push({
        key: 'developers',
        label: 'Developers',
        href: `../settings/developers`,
      });
    }

    return items;
  }, [space?.flags?.isDeveloperAccessible]);

  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Space settings',
    };

    uiStore.showBack = false;
  }, []);

  return <SettingsMenu items={menu} />;
});
